import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationSubscriptionChangePlanPatch = {
    path: "/subscription/change-plan",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationSubscriptionChangePlanPatch };
